import { getSpaceArray } from './utils/themeUtils';

export const theme = (overrides) => ({ space: getSpaceArray });
